<template>
  <v-container class="pa-0" fluid>
    <v-chip-group :column="showAllTags" multiple>
      <v-chip v-for="tag in tags" :key="tag._id" :style="setColor(tag.color)" @click="addTag(tag)">
        {{ tag.name }}
      </v-chip>
    </v-chip-group>
    <v-row>
      <v-spacer></v-spacer>
      <a v-if="tags.length" class="link mb-0 pr-4" @click="showAllTags = !showAllTags">
        {{ showAllTags ? 'mostrar menos' : 'mostrar todos' }}
      </a>
    </v-row>
    <v-row no-gutters>
      <span class="card-title pl-0"> Exibindo os marcadores: </span>
    </v-row>
    <v-row no-gutters>
      <v-chip-group column>
        <v-chip
          v-for="(tag, index) in filteredTags"
          :key="tag._id"
          :style="setColor(tag.color)"
          close-icon="close"
          close
          @click:close="filteredTags.splice(index, 1)"
        >
          {{ tag.name }}
        </v-chip>
      </v-chip-group>
    </v-row>
    <v-row v-if="filteredTags.length" class="mt-1" no-gutters>
      <v-col>
        <span class="link" @click="filteredTags = []"> Remover todos </span>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { QUERY_LIST_TEMPLATE_MESSAGE_TAGS } from './graphql'

export default {
  name: 'TemplateMessageTags',
  components: {},
  props: {
    value: {
      type: Array,
      required: true,
    },
  },
  data: () => ({
    showAllTags: false,
    defaultVariables: {
      page: 1,
      pageSize: 50,
    },
    tags: [],
  }),
  computed: {
    filteredTags: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
  },
  watch: {},
  mounted() {
    this.getTags()
  },
  methods: {
    getTags() {
      this.$apollo
        .query({
          query: QUERY_LIST_TEMPLATE_MESSAGE_TAGS,
          variables: this.defaultVariables,
        })
        .then(
          ({
            data: {
              messageTemplateTags: { tags },
            },
          }) => {
            this.tags = tags
          }
        )
    },
    addTag(tag) {
      const tagPosition = this.filteredTags.findIndex((filteredTag) => filteredTag._id === tag._id)

      if (tagPosition >= 0) {
        this.filteredTags.splice(tagPosition, 1)
        return
      }
      this.filteredTags.push(tag)
    },
    setColor(tagColor) {
      return `background-color: ${tagColor} !important`
    },
  },
}
</script>

<style lang="scss"></style>
